<div>
    <div class="form-group mt-4">
        <label for="nome" class="required">Nome</label>
        <input type="text" class="form-control" id="nome" name="nome" placeholder="Digite o nome" required
            maxlength="64" [(ngModel)]="paciente.nome" #nameModel="ngModel" #nameEl />
        <abp-validation-summary [control]="nameModel" [controlEl]="nameEl"></abp-validation-summary>
    </div>

    <div class="form-group">
        <label for="nomeSocial">Nome Social</label>
        <input type="text" class="form-control" id="nomeSocial" name="nomeSocial" placeholder="Nome social"
            maxlength="100" [(ngModel)]="paciente.nomeSocial" #nomeSocialModel="ngModel" #nomeSocialEl />
        <abp-validation-summary [control]="nomeSocialModel" [controlEl]="nomeSocialEl"></abp-validation-summary>
    </div>

    <div class="form-group" *ngIf="!ehEstrangeiro">
        <label for="cpf">CPF</label>
        <input autocomplete="off" type="text" class="form-control" id="cpf" name="cpf" placeholder="Digite o CPF"
            maxlength="14" mask="000.000.000-00" [(ngModel)]="paciente.cpf" disabled />
    </div>

    <div class="form-group" *ngIf="ehEstrangeiro">
        <label for="numeroPassaporte">Número do passaporte</label>
        <input autocomplete="off" type="text" class="form-control" id="numeroPassaporte" name="numeroPassaporte"
            placeholder="Digite o número do passaporte" [(ngModel)]="paciente.numeroPassaporte" disabled />
    </div>

    <div class="form-group">
        <label class="required" for="data-nascimento">Data de Nascimento</label>
        <input id="data-nascimento" type="text" class="form-control" name="dataNascimento" disabled
            placeholder="Data de nascimento" mask="00/00/0000" maxlength="10" required [ngModel]="dataNascimento" />
    </div>

    <div class="form-group">
        <label for="nomeMae">Nome da mãe</label>
        <input type="text" class="form-control" id="nomeMae" name="nomeMae" placeholder="Nome da mãe"
            [(ngModel)]="paciente.nomeMae" #nomeMaeModel="ngModel" #nomeMaeEl [ngModelOptions]="{ standalone: true }" />
        <abp-validation-summary [control]="nomeMaeModel" [controlEl]="nomeMaeEl"></abp-validation-summary>
    </div>

    <div class="form-group">
        <label for="religiao">Religião</label>
        <input type="text" class="form-control" id="religiao" name="religiao" placeholder="Religião"
            [(ngModel)]="paciente.religiao" #religiaoModel="ngModel" #religiaoEl
            [ngModelOptions]="{ standalone: true }" />
        <abp-validation-summary [control]="religiaoModel" [controlEl]="religiaoEl"></abp-validation-summary>
    </div>

    <div class="form-group" *ngIf="!paciente.isDependente">
        <label for="profissao">Profissão</label>
        <input type="text" class="form-control" id="profissao" name="profissao" placeholder="Profissão"
            [(ngModel)]="paciente.profissao" #profissaolLegalModel="ngModel" #profissaoLegalEl
            [ngModelOptions]="{ standalone: true }" />
        <abp-validation-summary [control]="profissaolLegalModel"
            [controlEl]="profissaoLegalEl"></abp-validation-summary>
    </div>

    <div class="form-group">
        <label for="sexo" class="required">Sexo</label>
        <select class="custom-select kt-input select-with-placeholder" id="sexo" name="sexo" required
            [(ngModel)]="paciente.sexo" #sexoModel="ngModel" #sexoEl>

            <option value="" disabled selected class="option-placeholder">
                Selecione o sexo
            </option>

            <option *ngFor="let sexo of listaSexo" [ngValue]="sexo.value">
                {{ sexo.name }}
            </option>
        </select>

        <abp-validation-summary [control]="sexoModel" [controlEl]="sexoEl"></abp-validation-summary>
    </div>

    <div class="form-group">
        <label for="tipoSanguineo">Tipo Sanguíneo</label>
        <select class="custom-select kt-input select-with-placeholder" id="tipoSanguineo" name="tipoSanguineo"
            [(ngModel)]="paciente.tipoSanguineo" #tipoSanguineoModel="ngModel" #tipoSanguineoEl>

            <option value="" disabled selected class="option-placeholder">
                Tipo Sanguíneo
            </option>

            <option *ngFor="let tipo of listaTipoSanguineo" [ngValue]="tipo.value">
                {{ tipo.name }}
            </option>
        </select>

        <abp-validation-summary [control]="tipoSanguineoModel" [controlEl]="tipoSanguineoEl"></abp-validation-summary>
    </div>

    <div class="form-group">
        <label for="corEtnia">Cor / Etnia</label>
        <select class="custom-select kt-input select-with-placeholder" id="corEtnia" name="corEtnia"
            [(ngModel)]="paciente.corEtnia" #corEtniaModel="ngModel" #corEtniaEl>

            <option value="" disabled selected class="option-placeholder">
                Cor / Etnia
            </option>

            <option *ngFor="let corEtnia of listaCorEtnia" [ngValue]="corEtnia.value">
                {{ corEtnia.name }}
            </option>
        </select>

        <abp-validation-summary [control]="corEtniaModel" [controlEl]="corEtniaEl"></abp-validation-summary>
    </div>

    <div class="form-group" *ngIf="!paciente.isDependente">
        <label for="estadoCivil">Estado Civil</label>
        <select class="custom-select kt-input select-with-placeholder" id="estadoCivil" name="estadoCivil"
            [(ngModel)]="paciente.estadoCivil" #estadoCivilModel="ngModel" #estadoCivilEl>

            <option value="" disabled selected class="option-placeholder">
                Estado Civil
            </option>

            <option *ngFor="let estadoCivil of listaEstadoCivil" [ngValue]="estadoCivil.value">
                {{ estadoCivil.name }}
            </option>
        </select>

        <abp-validation-summary [control]="estadoCivilModel" [controlEl]="estadoCivilEl"></abp-validation-summary>
    </div>

    <div class="form-group">
        <label for="cns">CNS</label>
        <input type="text" class="form-control" id="cns" name="cns" placeholder="CNS" mask="000 0000 0000 0000"
            [(ngModel)]="paciente.cns" pattern="(\d{3})(\d{4})(\d{4})(\d{4})" (blur)="cnsOnBlur()" #cnsModel="ngModel"
            #cnsEl />

        <abp-validation-summary [control]="cnsModel" [controlEl]="cnsEl"
            [customValidationErrors]="newCnsValidationErrors">
        </abp-validation-summary>
    </div>

    <div class="form-group" *ngIf="!paciente.isDependente">
        <label class="required" for="celular">Celular</label>
        <input id="celular" type="text" class="form-control" name="celular" placeholder="Celular" required
            maxlength="60" mask="(00) 00000-0000" [(ngModel)]="paciente.celular" #celularModel="ngModel" #celularEl />

        <abp-validation-summary [control]="celularModel" [controlEl]="celularEl"></abp-validation-summary>
    </div>

    <div class="form-group" *ngIf="!paciente.isDependente">
        <label for="email">E-mail</label>
        <input id="email" type="email" class="form-control" name="emailAddress" placeholder="E-mail" maxlength="256"
            [(ngModel)]="paciente.email" #emailAddressModel="ngModel" #emailAddressEl />

        <abp-validation-summary [control]="emailAddressModel" [controlEl]="emailAddressEl"></abp-validation-summary>
    </div>

    <div class="form-group" *ngIf="!paciente.isDependente">
        <label class="required" for="senha">Senha</label>

        <div class="input-group">
            <div class="input-group-append icon-div pass-posstion">
                <div class="input-group-text p-4"
                    style="cursor: pointer; padding-top: 0.9rem !important; padding-bottom: 0.9rem !important;"
                    (click)="visualizarSenha()">
                    <span class="fas" [ngClass]="!showPassword ? 'fa-eye-slash' : 'fa-eye'"></span>
                </div>
            </div>

            <input autocomplete="off" [type]="showPassword ? 'password' : 'text'" class="form-control" id="senha"
                name="password" placeholder="Senha" required maxlength="32" [(ngModel)]="paciente.senha"
                pattern="(?=^.{8,}$)(?=.*\d)(?=.*[a-zA-Z])(?!.*\s)[0-9a-zA-Z!.@#$%^&*()]*$" #passwordModel="ngModel"
                #passwordEl />
        </div>

        <abp-validation-summary [control]="passwordModel" [controlEl]="passwordEl"
            [customValidationErrors]="passwordValidationErrors"></abp-validation-summary>
    </div>
</div>